import ActionTypes from '../constants/ActionTypes';
import initialState from '../store/initialState';

export default (state = initialState.aiInterview, action) => {
  switch (action.type) {
    case ActionTypes.GET_INTERVIEW_SESSION: {
      return {
        ...state,
        interviewSession: null,
      };
    }
    case ActionTypes.GET_INTERVIEW_SESSION_SUCCESS: {
      return {
        ...state,
        interviewSession: action.payload,
      };
    }
    case ActionTypes.GET_INTERVIEW_SESSION_FAIL: {
      return {
        ...state,
        interviewSession: null,
      };
    }
    case ActionTypes.VALIDATE_DHWANI_INTERVIEW_SESSION: {
      return {
        ...state,
        validateDhwaniInterviewSession: {
          loading: true,
          data: null,
          error: null,
        },
      };
    }
    case ActionTypes.VALIDATE_DHWANI_INTERVIEW_SESSION_SUCCESS: {
      return {
        ...state,
        validateDhwaniInterviewSession: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    }
    case ActionTypes.VALIDATE_DHWANI_INTERVIEW_SESSION_FAIL: {
      return {
        ...state,
        validateDhwaniInterviewSession: {
          loading: false,
          data: null,
          error: action.error,
        },
      };
    }
    case ActionTypes.VALIDATE_DHWANI_INTERVIEW_SESSION_RESET: {
      return {
        ...state,
        validateDhwaniInterviewSession: {
          loading: false,
          data: null,
          error: null,
        },
      };
    }
    case ActionTypes.UPLOAD_CANDIDATE_CV: {
      return {
        ...state,
        cvUploaded: {
          loading: true,
          data: null,
          error: null,
        },
      };
    }
    case ActionTypes.UPLOAD_CANDIDATE_CV_SUCCESS: {
      return {
        ...state,
        cvUploaded: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    }
    case ActionTypes.UPLOAD_CANDIDATE_CV_FAIL: {
      return {
        ...state,
        cvUploaded: {
          loading: false,
          data: null,
          error: action.payload,
        },
      };
    }
    case ActionTypes.CV_GENERATION_STATUS: {
      return {
        ...state,
        cvGenerationStatus: null,
      };
    }
    case ActionTypes.CV_GENERATION_STATUS_SUCCESS: {
      return {
        ...state,
        cvGenerationStatus: true,
      };
    }
    case ActionTypes.CV_GENERATION_STATUS_FAIL: {
      return {
        ...state,
        cvGenerationStatus: false,
      };
    }
    case ActionTypes.CV_UPLOAD_STATUS: {
      return {
        ...state,
        cvUploadedDetails: null,
      };
    }
    case ActionTypes.CV_UPLOAD_STATUS_SUCCESS: {
      return {
        ...state,
        cvUploadedDetails: action.payload,
      };
    }
    case ActionTypes.CV_UPLOAD_STATUS_FAIL: {
      return {
        ...state,
        cvUploadedDetails: null,
      };
    }
    default:
      return state;
  }
};
